import { render, staticRenderFns } from "./Pencabutan.vue?vue&type=template&id=3d40774e&"
import script from "./Pencabutan.vue?vue&type=script&lang=js&"
export * from "./Pencabutan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports